import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext } from "react-router";

const Products = ({ menuGroups = [], products = [] }) => {
  const navigate = useNavigate();
  const { url } = useOutletContext();

  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const menuGroup = menuGroups[0];
  const hasMenuProducts = menuGroup?.products?.length > 0;
  const list = hasMenuProducts ? menuGroup.products : products;

  if (list.length === 0) return null;

  const handleNavigation = (id = null) => {
    if (id === null) navigate(`/shop/${url}/productsList`);
    else navigate(`/shop/${url}/productsView/${id}`);
  };

  return (
    <div className="products">
      <div className="info">
        <strong>{hasMenuProducts ? menuGroup.name : "인기상품"}</strong>
        <p>제일 잘 팔리는 상품으로만 구성했어요.</p>
      </div>
      <div className="inner">
        {isTablet ? (
          <Swiper slidesPerView={isMobile ? 1 : 2} spaceBetween={10} className="mySwiper">
            {list.map((item) => (
              <SwiperSlide onClick={() => handleNavigation(item.id)} className="item">
                <img
                  src={imgHandler(item?.media?.[0])}
                  alt={item.name}
                  onError={(e) => (e.target.src = "/img/shop_network.png")}
                />
                <span>{item.name}</span>
                <span>{formatNumber(item.price)}원</span>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <ul>
            {list.map((item) => (
              <li onClick={() => handleNavigation(item.id)} className="item">
                <img
                  src={imgHandler(item?.media?.[0])}
                  alt={item.name}
                  onError={(e) => (e.target.src = "/img/shop_network.png")}
                />
                <span>{item.name}</span>
                <span>{formatNumber(item.price)}원</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Products;
